import { trackPayLog } from './utils'
// import { passenger, hypassenger } from './xenv/passenger'
// import { esapp } from './xenv/esapp'
// import {
//   wxmp,
//   alimp,
//   qjwxmp,
//   sfcwxmp,
//   yxwxmp,
//   dymp,
//   hywxmp,
//   hyalimp,
//   cralimp,
//   hwfastapp,
//   sfcalimp,
// } from './xenv/mp_combine'
// import { h5 } from './xenv/h5'
import { payCenter } from '@didi/trade-sdk/lib/quartz-mall'
// const PayMethods = {
//   passenger,
//   esapp,
//   wxmp,
//   alimp,
//   qjwxmp,
//   sfcwxmp,
//   yxwxmp,
//   h5,
//   dymp,
//   hywxmp,
//   hyalimp,
//   cralimp,
//   hwfastapp,
//   sfcalimp,
//   hypassenger,
// }

/**
 * @typedef TMPOptions
 * @property {string} successUrl - 成功跳转的 URL （不含参数）
 * @property {Object} [successParams] - 成功跳转的 URL 的参数
 */

/**
 * @typedef TPayOptions
 * @property {TMPOptions} mp - 小程序配置
 * @property {string} orderId - 订单ID
 */

/**
 * 商城支付封装
 * @param {Object} payInfo
 * @param {TPayOptions} options - 前端支付配置
 * @returns
 */
export const mallPay = async (payInfo, options) => {
  try {
    // const env = pretreatEnv()
    // console.log('env===', env, payInfo, options)
    // if (PayMethods[env]) {
    //   const res = await PayMethods[env](payInfo, options)
    //   trackPayLog(payInfo, options)
    //   return res
    // } else {
    //   // TODO: 异常情况走到 H5，上报
    //   const res = await PayMethods.h5(payInfo, options)
    //   trackPayLog(payInfo, options)
    //   return res
    // }
    const res = payCenter(payInfo, options)
    return res
  } catch (error) {
    console.log('----mallPay- error---', error)
    if (error?.code !== 2) {
      trackPayLog(payInfo, options)
    }
    return Promise.reject(error)
  }
}
